import { toast } from "@/components/ui";
import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import type { RequestGroup } from "@curai/js-fhir-tools";
import { useQueryClient } from "@tanstack/react-query";

interface ChangePSCParams {
  pscLocationId: string;
}

interface ChangePSCResponse {
  requestGroup: RequestGroup;
}

export const useChangePSC = ({
  patientId,
  encounterId,
  requestGroupId,
}: {
  patientId: string;
  encounterId: string;
  requestGroupId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<ChangePSCResponse, ChangePSCParams>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.Chart.Labs.CHANGE_PSC({
        patientId,
        encounterId,
        requestGroupId,
      }),
      mutationFn: async (params) => {
        return axiosInstance.put(
          `/labs/order/v2/${requestGroupId}/psc`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Labs.DEFAULT({
            patientId,
            encounterId,
          }),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Labs.DEFAULT_V2({
            patientId,
            encounterId,
          }),
        });
      },
      onError: () => {
        toast.error("Failed to change PSC.");
      },
    },
  });
};
